import { render, staticRenderFns } from "./ShowModal.vue?vue&type=template&id=167fbf89&scoped=true&"
import script from "./ShowModal.vue?vue&type=script&lang=js&"
export * from "./ShowModal.vue?vue&type=script&lang=js&"
import style0 from "./ShowModal.vue?vue&type=style&index=0&id=167fbf89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167fbf89",
  null
  
)

component.options.__file = "ShowModal.vue"
export default component.exports